import * as React from "react";
import { cn } from "@/lib/utils";

const Button = React.forwardRef(({ className, variant = "primary", size = "default", ...props }, ref) => {
  const variants = {
    primary: "bg-primary text-primary-foreground hover:bg-primary-hover shadow-lg shadow-primary/20 hover:scale-[1.02] active:scale-[0.98]",
    secondary: "bg-secondary text-secondary-foreground hover:bg-secondary-hover shadow-md hover:-translate-y-0.5",
    outline: "border-2 border-primary text-primary hover:bg-primary-50",
    ghost: "text-slate-600 hover:text-primary hover:bg-primary-50",
  };

  const sizes = {
    default: "px-5 py-2.5 text-sm md:px-6 md:py-3 md:text-base",
    sm: "px-4 py-2 text-sm",
    lg: "px-8 py-3.5 text-base md:px-10 md:py-4 md:text-lg",
  };

  return (
    <button
      className={cn(
        "rounded-xl font-semibold transition-all duration-200 inline-flex items-center justify-center gap-2 disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap",
        variants[variant],
        sizes[size],
        className
      )}
      ref={ref}
      {...props}
    />
  );
});
Button.displayName = "Button";

export { Button };
